import { StringUtils } from '@sankhyalabs/core';
import FintechAPICaller from '../../../utils/FintechAPICaller';
import { generateIdempotencyKey } from '../../../utils/IdempotencyUtils';
import { API_PATHS } from '../constants';
import { IGetLatestScoreByDocumentResponse } from '../types/api';

export interface GetLatestScoreByDocumentOptions {
  document: string;
  refresh?: boolean;
  idempotencyKey?: string;
}

export async function getLatestScoreByDocument(
  options: GetLatestScoreByDocumentOptions,
): Promise<IGetLatestScoreByDocumentResponse> {
  const { document, refresh = false, idempotencyKey } = options;
  const resolvedKey = idempotencyKey ?? (await generateIdempotencyKey(document, StringUtils.generateUUID()));

  const params: Record<string, unknown> = { refresh };

  const axiosResponse = await FintechAPICaller.get({
    servicePath: API_PATHS.GET_LATEST_SCORE_BY_DOCUMENT(document),
    params,
    extraHeaders: {
      'Idempotency-Key': resolvedKey,
    },
  });

  if (!axiosResponse?.data) {
    throw new Error('Erro ao buscar score por documento');
  }

  return axiosResponse.data as IGetLatestScoreByDocumentResponse;
}
